<template>
  <Header />
  <div class="errorPage">
    <div class="apiError container--Small">
      <div class="apiError__ImageWrapper">
        <Icon name="laptop" />
      </div>

      <div class="apiError__Content">
        <template v-if="error.statusCode === 404">
          <h1>{{ error.statusCode }}</h1>
          <p v-text="$t('error.missingPageText')" />
          <Button type="nuxt-link" :to="`/${ lang }/`" class="apiError__ReturnButton">{{ $t('error.missingPageButton') }}</Button>
        </template>
        <template v-else>
          <h1 v-text="$t('error.title')" />
          <p v-text="$t('error.generalText')" />
        </template>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script setup>
  const props = defineProps({
    error: {}
  })

  const { init } = useSetup();
  const { lang, setLanguage } = useLanguage();
  await setLanguage()
  await init()
  
  useHead({
    htmlAttrs: {
      class: 'isError'
    }
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_apiError.scss');
</style>